import axios from "axios";
import { baseUrl } from "../Common/Constants";
import httpClient from "../Core/http";

class Api{
    getInterruptData(params:any):Promise<any>{
    
        const termsObj = {
            seriesObjects:params.seriesObjects
        }
        const terms = JSON.stringify(termsObj)
        

        const queryObject = {
            bucketSize: params.bucketSize,
            start: params.start,
            end: params.end,
            terms: terms,
        }
    
        let url ="interrupt";
        return  httpClient.get<any[]>(url,{params:queryObject}).then((response:any) => {
            return response.data
        })

        .catch((error) => {
            throw error;
            console.log(error);
        });
 
    }
}

export const InterrutApi = new Api();